import * as mns from '../../mutation-types';

export default {
    state () {
        return {
            date: '',
            event: '',
            cause: '',
            address: '',
            comments: '',
        }
    },
    getters: {
        date(state){
            return state.date;
        },
        event(state){
            return state.event;
        },
        cause(state){
            return state.cause;
        },
        address(state){
            return state.address;
        },
        comments(state){
            return state.comments;
        },
    },
    mutations: {
        [mns.SET_DATE](state, value){
            state.date = value;
        },
        [mns.SET_EVENT](state, value){
            state.event = value;
        },
        [mns.SET_CAUSE](state, value){
            state.cause = value;
        },
        [mns.SET_ADDRESS](state, value){
            state.address = value;
        },
        [mns.SET_COMMENTS](state, value){
            state.comments = value;
        },
    }
} // export.